// 自動生成。直接編集しない。
//   node scripts/gen-tarkov-maps.js
//
// 座標変換・SVG のレイヤー id・ラベルの出所は the-hideout/tarkov-dev の
// src/data/maps.json (MIT)。マップ id は json.tarkov.dev。
// SVG そのもの (public/maps/svg/) は CC BY-NC-SA 4.0 — 詳しくは NOTICE.md を見ること。
import type { TarkovMapDef } from './tarkovMaps'

export const TARKOV_MAP_DEFS: Record<string, TarkovMapDef> = {
  "streets-of-tarkov": {
    normalizedName: "streets-of-tarkov",
    id: "5714dc692459777137212e12",
    displayName: "Streets of Tarkov",
    svg: "/maps/svg/StreetsOfTarkov.svg",
    svgLayer: "Ground_Level",
    transform: [0.38, 0, 0.38, 0],
    coordinateRotation: 180,
    bounds: [[323, -295], [-280, 532]],
    heightRange: [-6, 10],
    minZoom: 1,
    maxZoom: 5,
    layers: [
      { name: "2nd Floor", svgLayer: "Second_Floor", show: false, height: [10, 15] },
      { name: "3rd Floor", svgLayer: "Third_Floor", show: false, height: [15, 20] },
      { name: "4th Floor", svgLayer: "Fourth_Floor", show: false, height: [20, 25] },
      { name: "5th Floor", svgLayer: "Fifth_Floor", show: false, height: [25, 10000] },
      { name: "Underground", svgLayer: "Underground_Level", show: false, height: [-10000, -6] },
    ],
    labels: [
      { position: [9, 308], text: "Primorsky Ave.", rotation: -90, size: 80 },
      { position: [9, 104], text: "Primorsky Ave.", rotation: -90, size: 80 },
      { position: [9, -80], text: "Primorsky Ave.", rotation: -90, size: 80 },
      { position: [125, 10], text: "Kilmov St.", size: 80 },
      { position: [-104, 28], text: "Kilmov St.", rotation: 10, size: 80 },
      { position: [-125, 210], text: "Nikitskaya St.", size: 80 },
      { position: [-112, 361], text: "Verhnyaya St.", size: 80 },
      { position: [-200, 290], text: "Malevecha St.", rotation: -64, size: 80 },
      { position: [111, 251], text: "Chekannaya St.", size: 80 },
      { position: [-101, 441], text: "Nizhnyaya St.", size: 80 },
      { position: [174, 430], text: "Razvedchikov St.", rotation: -30, size: 80 },
      { position: [140, 150], text: "Zmejskij Alley", rotation: -68, size: 80 },
      { position: [232, 100], text: "Kamchatskaya St.", rotation: -90, size: 80 },
      { position: [-128, -35], text: "Kilmov Shopping Mall", size: 90 },
      { position: [-45, -52], text: "Beluga", size: 90 },
      { position: [99, -71], text: "Cardinal Apartments", size: 90 },
      { position: [230, 295], text: "Construction", size: 90 },
      { position: [66, 305], text: "Lexos", size: 90 },
      { position: [140, 300], text: "Sparja Grocery", size: 90 },
      { position: [-175, 400], text: "Cinema", size: 90 },
      { position: [-218, 135], text: "Shestyorochka", size: 90 },
      { position: [-35, 64], text: "Pinewood Hotel", size: 90 },
      { position: [65, 398], text: "Teppakot / Koener", size: 70 },
      { position: [140, 362], text: "Concordia", size: 70 },
      { position: [89, -20], text: "Cardinal Bank", size: 70 },
      { position: [239, -60], text: "LERM Expo", size: 70 },
      { position: [-64, 166], text: "Sparja Express", size: 70 },
      { position: [-30, 138], text: "Burger Spot", size: 70 },
      { position: [42, 97], text: "Post Office", size: 70 },
      { position: [42, 160], text: "Pharmacy 1", size: 70 },
      { position: [-173, 226], text: "Office", size: 70 },
      { position: [-197, 340], text: "Corner Restaurant", size: 70 },
      { position: [-43, 335], text: "Pharmacy 2", size: 70 },
      { position: [90, -277], text: "Pharmacy 3", size: 70 },
      { position: [67, 230], text: "Tarbank", size: 70 },
      { position: [211, 129], text: "School", size: 70 },
      { position: [222, 173], text: "Vet Clinic", size: 70 },
      { position: [-212, 300], text: "Hive", size: 70 },
      { position: [-223, 279], text: "Family Market", size: 70 },
      { position: [-200, 248], text: "Marked Hotel", size: 70 },
      { position: [-175, 297], text: "South Hotel", size: 70 },
      { position: [-119, 287], text: "Abandon Factory", size: 70 },
      { position: [-80, 235], text: "Diner", size: 70 },
      { position: [-13, 244], text: "Primorskij 49", size: 70 },
      { position: [39, 230], text: "Prestigio Cafe", rotation: -45, size: 60 },
      { position: [-70, 343], text: "Bilbo Coffee", size: 60 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  "ground-zero": {
    normalizedName: "ground-zero",
    id: "653e6760052c01c1c805532f",
    displayName: "Ground Zero",
    svg: "/maps/svg/GroundZero.svg",
    svgLayer: "Ground_Level",
    transform: [0.524, 167.3, 0.524, 65.1],
    coordinateRotation: 180,
    bounds: [[249, -124], [-99, 364]],
    heightRange: [-1000, 28],
    minZoom: 1,
    maxZoom: 6,
    altNames: ["ground-zero-21", "ground-zero-tutorial"],
    layers: [
      {
        name: "2nd Floor",
        svgLayer: "Second_Floor",
        show: false,
        height: [26, 32.3],
        extents: [{ height: [28, 32.3] }, { height: [26, 31], bounds: [[[98, 216], [91, 228], "m showroom"]] }],
      },
      { name: "3rd Floor", svgLayer: "Third_Floor", show: false, height: [32.3, 1000] },
      {
        name: "Garage",
        svgLayer: "Underground_Level",
        show: false,
        height: [-1000, 21],
        extents: [
          {
            height: [-1000, 21],
            bounds: [[[117, -100], [43, 190], "garage"], [[143, 49], [117, 80], "underpass"]],
          },
        ],
      },
    ],
    labels: [
      { position: [-50, 0], text: "TerraGroup" },
      { position: [150, 1], text: "Skyside" },
      { position: [141, 142], text: "Fusion" },
      { position: [14, 201], text: "Empire" },
      { position: [115, 285], text: "Capital Insight" },
      { position: [2, 324], text: "Nakatani" },
      { position: [80, -118], text: "Elemental Global" },
      { position: [115, 104], text: "Oasis", size: 70, top: 30, bottom: 22 },
      { position: [115, 30], text: "ASAP Winery", size: 70, top: 27, bottom: 22 },
      { position: [43, 150], text: "Tarbank", size: 70 },
      { position: [58, 234], text: "GAGRIN Hotel", size: 70 },
      { position: [97, 223], text: "M Showroom", size: 70 },
      { position: [-13, 48], text: "Science Office", size: 60, top: 28, bottom: 28 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  customs: {
    normalizedName: "customs",
    id: "56f40101d2720b2a4d8b45d6",
    displayName: "Customs",
    svg: "/maps/svg/Customs.svg",
    svgLayer: "Ground_Level",
    transform: [0.239, 168.65, 0.239, 136.35],
    coordinateRotation: 180,
    bounds: [[698, -307], [-372, 237]],
    heightRange: [-1000, 1000],
    minZoom: 2,
    maxZoom: 6,
    layers: [
      {
        name: "2nd Floor",
        svgLayer: "Second_Floor",
        show: false,
        height: [2.7, 1000],
        extents: [
          {
            height: [2.7, 6.5],
            bounds: [
              [[243, 190], [165, 125], "dorms"],
              [[116, -83], [72, -170], "mechanic"],
              [[356, -30], [341, -84], "switch 2nd"],
              [[334, -52], [321, -59], "switch 2nd"],
              [[589, 10], [577, -1], "scav checkpoint"],
              [[580, -104], [532, -134], "dead scav warehouse"],
              [[625, -120], [599, -139], "pump 2nd"],
            ],
          },
          {
            height: [5.7, 1000],
            bounds: [
              [[580, -104], [532, -134], "dead scav warehouse"],
              [[-199, -90], [-223, -131], "big red 2nd"],
              [[239, 3], [169, -160], "skeleton"],
              [[336, -56], [316, -95], "switch snipe"],
              [[584, -46], [556, -92], "USEC 2nd"],
              [[93, 0], [65, -22], "construction 2nd"],
            ],
          },
          { height: [14, 15], bounds: [[[497, -44], [450, -90], "chemical warehouse sniper scav"]] },
          { height: [3.9, 7.6], bounds: [[[73, 57], [22, -38], "warehouse 17"]] },
          { height: [4.4, 6.5], bounds: [[[119, -57], [100, -42], "boiler"]] },
          { height: [4.6, 7.9], bounds: [[[279, -79], [246, -1.4], "oilrig & panda"]] },
        ],
      },
      {
        name: "3rd Floor",
        svgLayer: "Third_Floor",
        show: false,
        height: [5.7, 1000],
        extents: [
          { height: [5.7, 1000], bounds: [[[243, 190], [165, 125], "dorms"]] },
          { height: [7.7, 11.3], bounds: [[[73, -73], [22, -38], "warehouse 17"]] },
          { height: [6.7, 11.6], bounds: [[[126, -64], [88, -35], "boiler"]] },
          { height: [8, 11.1], bounds: [[[279, -79], [246, -1.4], "oilrig & panda"]] },
        ],
      },
      {
        name: "Underground",
        svgLayer: "Underground_Level",
        show: false,
        height: [-1000, 0.5],
        extents: [
          {
            height: [-1000, 0.5],
            bounds: [
              [[635, -137], [620, -125], "zb-1011"],
              [[473, -122], [458, -110], "zb-1012"],
              [[314, -173], [308, -184], "old gas"],
              [[349, -88], [323, -32], "switch basement"],
              [[219, -158], [193, -137], "zb-013"],
              [[122, -61], [88, -40], "boiler room"],
            ],
          },
        ],
      },
    ],
    labels: [
      { position: [-215, -119], text: "Big Red" },
      { position: [200, 150], text: "Dorms" },
      { position: [404, 31], text: "New Gas" },
      { position: [331, -173], text: "Old Gas" },
      { position: [201, -127], text: "Fortress" },
      { position: [83, -153], text: "Crackhouse" },
      { position: [567, -67], text: "Streamer House", size: 90 },
      { position: [-69, 9], text: "Main Bridge", rotation: 6, size: 90 },
      { position: [110, 85], text: "Sniper Hill", size: 90 },
      { position: [-288, -134], text: "Storage", size: 90 },
      { position: [-211, -219], text: "Trailer Park", size: 90 },
      { position: [-66, 46], text: "Junk Bridge", size: 90 },
      { position: [106, -90], text: "Repair Shop", size: 90 },
      { position: [491, 63], text: "Sniper Ridge", rotation: 5 },
      { position: [75, -9], text: "Old Construction", size: 90 },
      { position: [200, -13], text: "Skeleton", rotation: -9 },
      { position: [390, -94], text: "Warehouse 3" },
      { position: [472, -67], text: "Depot" },
      { position: [555, -118], text: "Warehouse 7" },
      { position: [572, 0], text: "Military Checkpoint" },
      { position: [238, 53], text: "Bus Station", size: 90 },
      { position: [333, -67], text: "Warehouse 4" },
      { position: [497, 110], text: "Powerline Tower" },
      { position: [46, -59], text: "Warehouse 17", size: 90 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  factory: {
    normalizedName: "factory",
    id: "55f2d3fd4bdc2d5f408b4567",
    displayName: "Factory",
    svg: "/maps/svg/Factory.svg",
    svgLayer: "Ground_Floor",
    transform: [1.629, 119.9, 1.629, 139.3],
    coordinateRotation: 90,
    bounds: [[77, -64.5], [-65.5, 67.4]],
    heightRange: [-1, 3],
    minZoom: 1,
    maxZoom: 6,
    altNames: ["night-factory"],
    layers: [
      { name: "2nd Floor", svgLayer: "Second_Floor", show: false, height: [3, 6] },
      { name: "3rd Floor", svgLayer: "Third_Floor", show: false, height: [6, 10000] },
      { name: "Tunnels", svgLayer: "Basement", show: false, height: [-10000, -1] },
    ],
    labels: [
      { position: [21, 39], text: "Office Building", size: 80, top: 10000, bottom: -1 },
      { position: [15.5, 39], text: "Main Office", size: 80, top: 10000, bottom: 6 },
      { position: [24.5, 39], text: "Breach Room", size: 80, top: 10000, bottom: 6 },
      { position: [30.5, 39], text: "Locked Office", size: 80, top: 10000, bottom: 6 },
      { position: [35, 39], text: "North Stairs", size: 80, top: 10000, bottom: -1 },
      { position: [9, 39], text: "South Stairs", size: 80, top: 10000, bottom: -1 },
      { position: [34, 26], text: "Sky Bridge", size: 80, top: 10000, bottom: 6 },
      { position: [29.5, 17], text: "Connector", size: 80, top: 10000, bottom: -1 },
      { position: [29, 41], text: "Locker Rooms", size: 80, top: 5, bottom: 3 },
      { position: [15, 41], text: "Sinks", size: 80, top: 5, bottom: 3 },
      { position: [20, 42], text: "Hole", size: 80, top: 5, bottom: 3 },
      { position: [-3, 37], text: "Platform", size: 80, top: 5, bottom: -1 },
      { position: [-21, 27], text: "Servers", size: 80, top: 5, bottom: 3 },
      { position: [-18, -29], text: "Med Tent", size: 80, top: 2, bottom: -1 },
      { position: [4.5, 10.5], text: "Silos", top: 2, bottom: -1 },
      { position: [30, -8.5], text: "Heli Crash", size: 80, top: 10000, bottom: -1 },
      { position: [-1, 16], text: "Pit", size: 80, top: -2, bottom: -10000 },
      { position: [-2, -24.5], text: "Underground Stash", size: 80, top: -2, bottom: -10000 },
      { position: [-20.5, 23], text: "Scav Bunker", size: 80, top: 2, bottom: -1 },
      { position: [-18, 50], text: "Blue Containers", top: 2, bottom: -1 },
      { position: [-45.5, 61], text: "Wood Room", size: 80, top: 2, bottom: -1 },
      { position: [68.25, -20], text: "Glass Hall", size: 80, top: 2, bottom: -1 },
      { position: [56, 5], text: "Boilers", size: 80, top: 5, bottom: -1 },
      { position: [41, -11], text: "Pumping Station", size: 80, top: 5, bottom: -1 },
      { position: [44, -36], text: "East Halls", size: 80, top: 2, bottom: -1 },
      { position: [66, -42], text: "Forklifts", size: 80, top: 2, bottom: -1 },
      { position: [18, 4], text: "Rafters", top: 10000, bottom: 6 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  interchange: {
    normalizedName: "interchange",
    id: "5714dbc024597771384a510d",
    displayName: "Interchange",
    svg: "/maps/svg/Interchange.svg",
    svgLayer: "Ground_Level",
    transform: [0.265, 150.6, 0.265, 134.6],
    coordinateRotation: 180,
    bounds: [[598, -442], [-433, 426]],
    minZoom: 1,
    maxZoom: 6,
    layers: [
      {
        name: "2nd Floor",
        svgLayer: "First_Floor",
        show: true,
        height: [25, 34],
        extents: [{ height: [25, 34], bounds: [[[120, 218], [-222, -327], "mall"]] }],
      },
      {
        name: "3rd Floor",
        svgLayer: "Second_Floor",
        show: false,
        height: [34, 1000],
        extents: [{ height: [34, 1000], bounds: [[[120, 218], [-222, -327], "mall"]] }],
      },
    ],
    labels: [
      { position: [-186.4, -318.7], text: "Power Station", size: 100, top: 10, bottom: -1 },
      { position: [155, -253], text: "Go Kart", size: 80, top: 10, bottom: -1 },
      { position: [158, -78.5], text: "Four Camp", size: 80, top: 10, bottom: -1 },
      { position: [68.2, 312.9], text: "Cargo Containers", size: 80, top: 10, bottom: -1 },
      { position: [-260.2, 123.8], text: "Wall Break", size: 80, top: 10, bottom: -1 },
      { position: [-175.5, 145.1], text: "Ramps", size: 80, top: 10, bottom: -1 },
      { position: [202.3, 219.4], text: "Oli Tower", size: 80, top: 10, bottom: -1 },
      { position: [46.5, -358.5], text: "Idea Tower", size: 80, top: 10, bottom: -1 },
      { position: [263.2, -11.1], text: "Scav Camp", size: 80, top: 10, bottom: -1 },
      { position: [373.5, -391.2], text: "Highway Construction", top: 10, bottom: -1 },
      { position: [33, -222], text: "Garage A", size: 80, top: 24, bottom: -1000 },
      { position: [47, -112], text: "Garage B", size: 80, top: 24, bottom: -1000 },
      { position: [0, 47], text: "Garage C", size: 80, top: 24, bottom: -1000 },
      { position: [20, 138], text: "Garage D", size: 80, top: 24, bottom: -1000 },
      { position: [-34, -235], text: "IDEA", size: 80, top: 33, bottom: 25 },
      { position: [-115, -45], text: "Goshan", size: 80, top: 33, bottom: 25 },
      { position: [-28, 140], text: "OLI", size: 80, top: 33, bottom: 25 },
      { position: [87, -165], text: "Nortex", size: 65, top: 33, bottom: 25 },
      { position: [60, -152], text: "TRend", size: 65, top: 33, bottom: 25 },
      { position: [69.5, -134], text: "Mode7", size: 65, top: 33, bottom: 25 },
      { position: [19, -129], text: "TTS", size: 65, top: 33, bottom: 25 },
      { position: [-38, -129], text: "Book Store", size: 65, top: 33, bottom: 25 },
      { position: [91, -119], text: "Dino Clothes", size: 65, top: 33, bottom: 25 },
      { position: [18, -103], text: "EMERCOM", size: 65, top: 33, bottom: 25 },
      { position: [-28, -103], text: "Kostin", size: 65, top: 33, bottom: 25 },
      { position: [-65, -103], text: "Bizarro", size: 65, top: 33, bottom: 25 },
      { position: [92, -87], text: "Spiel", size: 65, top: 33, bottom: 25 },
      { position: [-18, -87], text: "Voyage", size: 65, top: 33, bottom: 25 },
      { position: [57, -66], text: "Viking", size: 65, top: 33, bottom: 25 },
      { position: [13, -66], text: "Mantis", size: 65, top: 33, bottom: 25 },
      { position: [-18, -72], text: "German", size: 65, top: 33, bottom: 25 },
      { position: [57, -32], text: "The National", size: 65, top: 33, bottom: 25 },
      { position: [13, -32], text: "Brutal", size: 65, top: 33, bottom: 25 },
      { position: [-18, -25], text: "Kiba", size: 65, top: 33, bottom: 25 },
      { position: [-34, -20], text: "Pretty Lights", size: 65, top: 33, bottom: 25 },
      { position: [92, -18], text: "Telespot", size: 65, top: 33, bottom: 25 },
      { position: [62, -12], text: "Revis", size: 65, top: 33, bottom: 25 },
      { position: [19, -6], text: "ADIK", size: 65, top: 33, bottom: 25 },
      { position: [-28, 0.5], text: "Generic", size: 65, top: 33, bottom: 25 },
      { position: [92, 15], text: "Top Brand", size: 65, top: 33, bottom: 25 },
      { position: [61, 15], text: "Sports", size: 65, top: 33, bottom: 25 },
      { position: [70, 32], text: "Yushka", size: 65, top: 33, bottom: 25 },
      { position: [19.5, 26], text: "Rasmussen", size: 65, top: 33, bottom: 25 },
      { position: [-37, 26], text: "Avokado", size: 65, top: 33, bottom: 25 },
      { position: [91, 55], text: "Boots 4 Life", size: 65, top: 33, bottom: 25 },
      { position: [61, 50], text: "Texho", size: 65, top: 33, bottom: 25 },
      { position: [6, 49], text: "Dom", size: 65, top: 33, bottom: 25 },
      { position: [38, -170], text: "Father & Sons", size: 65, top: 999, bottom: 34 },
      { position: [69, -150], text: "Tarkovstar", size: 65, top: 999, bottom: 34 },
      { position: [26, -149], text: "Eastland", size: 65, top: 999, bottom: 34 },
      { position: [71, -130], text: "Arena", size: 65, top: 999, bottom: 34 },
      { position: [54, -128], text: "ТАРЗДРАВ", size: 65, top: 999, bottom: 34 },
      { position: [20, -128], text: "МЕБЕЛЬ МК", size: 65, top: 999, bottom: 34 },
      { position: [69, -116], text: "Intourist", size: 65, top: 999, bottom: 34 },
      { position: [-27, -103], text: "Burger Spot", size: 65, top: 999, bottom: 34 },
      { position: [70, -94], text: "FCK", size: 65, top: 999, bottom: 34 },
      { position: [70, -87], text: "McDaniels", size: 65, top: 999, bottom: 34 },
      { position: [64, -69], text: "Tarducks", size: 65, top: 999, bottom: 34 },
      { position: [43, -69], text: "Coffee Joy", size: 65, top: 999, bottom: 34 },
      { position: [15, -74], text: "Jacob & Jacob", size: 65, top: 999, bottom: 34 },
      { position: [-34, -79], text: "ПУШКИН", size: 65, top: 999, bottom: 34 },
      { position: [64, -34], text: "Sushi Huyushi", size: 65, top: 999, bottom: 34 },
      { position: [-17, -32], text: "Underway", size: 65, top: 999, bottom: 34 },
      { position: [67, -23.5], text: "Burger House", size: 65, top: 999, bottom: 34 },
      { position: [-34, -24], text: "Philly Cute", size: 65, top: 999, bottom: 34 },
      { position: [67, -16], text: "Shiccos", size: 65, top: 999, bottom: 34 },
      { position: [17, 0], text: "МУЗЕЙ ИСТОРИИ", size: 65, top: 999, bottom: 34 },
      { position: [92, 17], text: "Papillon", size: 65, top: 999, bottom: 34 },
      { position: [58, 13], text: "ЗАКРЫТО НА РЕМОНТ", size: 60, top: 999, bottom: 34 },
      { position: [70, 27], text: "НА-СВЯЗИ", size: 65, top: 999, bottom: 34 },
      { position: [54, 24], text: "СКОРО ОТКРЫТИЕ", size: 65, top: 999, bottom: 34 },
      { position: [19, 26], text: "Figaro", size: 65, top: 999, bottom: 34 },
      { position: [71, 47], text: "АПТЕКА", size: 65, top: 999, bottom: 34 },
      { position: [53, 47], text: "SARA", size: 65, top: 999, bottom: 34 },
      { position: [26, 46], text: "Urban Clothes", size: 65, top: 999, bottom: 34 },
      { position: [91, 54], text: "TECHLIGHT", size: 65, top: 999, bottom: 34 },
      { position: [39, 67], text: "Fashion Store", size: 65, top: 999, bottom: 34 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  lighthouse: {
    normalizedName: "lighthouse",
    id: "5704e4dad2720bb55b8b4567",
    displayName: "Lighthouse",
    svg: "/maps/svg/Lighthouse.svg",
    svgLayer: "Ground_Level",
    transform: [0.2, 0, 0.2, 0],
    coordinateRotation: 180,
    bounds: [[515, -998], [-545, 725]],
    minZoom: 1,
    maxZoom: 6,
    labels: [
      { position: [-30, -882], text: "Train Yard" },
      { position: [-120, -841], text: "Drug Lab" },
      { position: [-65, -600], text: "Water Treatment" },
      { position: [40, -618], text: "Plant 1" },
      { position: [-97, -737], text: "Plant 2" },
      { position: [-189, -665], text: "Plant 3" },
      { position: [-182, -552], text: "Pipes" },
      { position: [18, -453], text: "Gunner Nest" },
      { position: [-177, -356], text: "Island" },
      { position: [-278, -323], text: "Cabins" },
      { position: [-162, -225], text: "Cottages" },
      { position: [-55, -288], text: "Convenience" },
      { position: [-75, -284], text: "Red Brick" },
      { position: [-151, -243], text: "Hillside" },
      { position: [125, -153], text: "Boathouses" },
      { position: [62, -60], text: "Dead Tree" },
      { position: [0, -188], text: "Construction" },
      { position: [-107, -53], text: "Pikes Peak Resort" },
      { position: [-133, 100], text: "Grand Chalet" },
      { position: [-70, 129], text: "Tennis Court" },
      { position: [382, 496], text: "Lightkeeper Island" },
      { position: [-125, 296], text: "Crash Site" },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  reserve: {
    normalizedName: "reserve",
    id: "5704e5fad2720bc05b8b4567",
    displayName: "Reserve",
    svg: "/maps/svg/Reserve.svg",
    svgLayer: "Ground_Level",
    transform: [0.395, 122, 0.395, 137.65],
    coordinateRotation: 180,
    bounds: [[289, -293], [-303, 244]],
    svgBounds: [[289, -274], [-303, 272]],
    heightRange: [-7, 10000],
    minZoom: 2,
    maxZoom: 6,
    layers: [
      {
        name: "Bunkers",
        svgLayer: "Bunkers",
        show: false,
        height: [-10000, 18],
        extents: [
          {
            height: [-10000, -7.27],
            bounds: [[[128, -208], [18, -33], "storage bunker"], [[-46, -42], [-176, 127], "command bunkers"]],
          },
          { height: [-10000, -12], bounds: [[[-40, 124], [-124, 189], "D2"]] },
          { height: [-10000, 18], bounds: [[[23, 173], [-65, 189], "dome tunnels"]] },
          { height: [-7.27, -3.2], bounds: [[[74, -196], [19, -149], "bunker hermetic door bunkers"]] },
          {
            height: [-11, -4.6],
            bounds: [[[-246, -79], [-274, -53], "E1 bunkers"], [[238, -26], [126, 45], "bunkers"]],
          },
        ],
      },
    ],
    labels: [
      { position: [28, -102], text: "K Buildings", bottom: -6 },
      { position: [-25, 180], text: "White Queen", rotation: -15, bottom: -6 },
      { position: [-104, 93], text: "White Pawn", rotation: 14, bottom: -6 },
      { position: [-140, -14.5], text: "Black Bishop", rotation: 14, bottom: -6 },
      { position: [-67, -30], text: "White Bishop", rotation: 14, bottom: -6 },
      { position: [-49.5, 15.5], text: "White King", rotation: 14, bottom: -6 },
      { position: [14.5, -10.8], text: "Black Knight", bottom: -6 },
      { position: [82.2, -30.2], text: "White Knight", bottom: -6 },
      { position: [149, -124], text: "White Rook", bottom: -6 },
      { position: [161, -149], text: "Train Station", rotation: 14, size: 80, bottom: -6 },
      { position: [-165, 57], text: "Black Pawn", rotation: -75, bottom: -6 },
      { position: [167, -222], text: "Barracks", bottom: -6 },
      { position: [-220, -13], text: "E1 Bunkers", bottom: -6 },
      { position: [173, -3], text: "E2 Bunkers", bottom: -6 },
      { position: [80, -167], text: "д - Warehouse Bunkers", rotation: 14, bottom: -6 },
      { position: [96, 30], text: "Garage", rotation: -75, size: 80, bottom: -6 },
      { position: [55.5, 60.6], text: "Mechanic", size: 80, bottom: -6 },
      { position: [29.7, 29.5], text: "Gas Station", rotation: 14, size: 80, bottom: -6 },
      { position: [-31, -150], text: "Shipping Yard", rotation: 14, size: 80, bottom: -6 },
      { position: [-1, -71], text: "K1", rotation: 14, size: 80, bottom: -6 },
      { position: [66, -90], text: "K2", rotation: 14, size: 80, bottom: -6 },
      { position: [-5.5, -94], text: "K3", rotation: 14, size: 80, bottom: -6 },
      { position: [60, -112], text: "K4", rotation: 14, size: 80, bottom: -6 },
      { position: [-10.5, -115], text: "K5", rotation: 14, size: 80, bottom: -6 },
      { position: [54, -132], text: "K6", rotation: 14, size: 80, bottom: -6 },
      { position: [-8.5, 175], text: "Dome", size: 80, bottom: -6 },
      { position: [-120, 37], text: "Tarmac", rotation: 14, size: 80, bottom: -6 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  shoreline: {
    normalizedName: "shoreline",
    id: "5704e554d2720bac5b8b456e",
    displayName: "Shoreline",
    svg: "/maps/svg/Shoreline.svg",
    svgLayer: "Ground_Level",
    transform: [0.16, 83.2, 0.16, 111.1],
    coordinateRotation: 180,
    bounds: [[504, -415], [-1056, 618]],
    heightRange: [-1000, -1],
    minZoom: 2,
    maxZoom: 6,
    layers: [
      { name: "2nd Floor", svgLayer: "Second_Floor", show: false, height: [-1, 2] },
      { name: "3rd Floor", svgLayer: "Third_Floor", show: false, height: [2, 1000] },
      {
        name: "Underground",
        svgLayer: "Underground_Level",
        show: false,
        height: [-1000, -5],
        extents: [
          {
            height: [-1000, -5],
            bounds: [[[-137, -68], [-237, -104], "west wing"], [[-234, -134], [-268, -163], "admin"]],
          },
        ],
      },
    ],
    labels: [
      { position: [-258.2, -71.2], text: "Resort", size: 100, top: -2, bottom: -4 },
      { position: [-215.8, 178.4], text: "Power Station", top: -2, bottom: -4 },
      { position: [-189.3, 420], text: "Gas Station", top: -2, bottom: -4 },
      { position: [-496, 257], text: "Weather Station", top: -2, bottom: -4 },
      { position: [-708.9, 93.91], text: "Radio Tower", top: -2, bottom: -4 },
      { position: [326, -118.5], text: "Swamp", top: -2, bottom: -4 },
      { position: [418.4, 118], text: "Village", top: -2, bottom: -4 },
      { position: [288, 144], text: "Cabins", top: -2, bottom: -4 },
      { position: [128, 93], text: "Cottages", top: -2, bottom: -4 },
      { position: [-355, 188], text: "Tank Bridge", top: -2, bottom: -4 },
      { position: [-338.6, 525], text: "Pier", top: -2, bottom: -4 },
      { position: [216, 424], text: "Scav Island", top: -2, bottom: -4 },
      { position: [-96, -6], text: "Bus Stop", top: -2, bottom: -4 },
      { position: [52, 134], text: "Construction", top: -2, bottom: -4 },
      { position: [-153, -290], text: "Bunker", top: -2, bottom: -4 },
      { position: [-625, 484], text: "Crane", top: -2, bottom: -4 },
      { position: [-622, -202], text: "Scav Farm", top: -2, bottom: -4 },
      { position: [-171, -83], text: "West Wing", top: 100, bottom: -100 },
      { position: [-329, -83], text: "East Wing", top: 100, bottom: -100 },
      { position: [-252, -146], text: "Admin", top: 100, bottom: -100 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  terminal: {
    normalizedName: "terminal",
    id: "65cc8f81a9aac3e77d0cfd3e",
    displayName: "Terminal",
    svg: "/maps/svg/Terminal.svg",
    svgLayer: "Ground_Level",
    transform: [0.2, 0, 0.2, 0],
    coordinateRotation: 180,
    bounds: [[463, -580], [-433, 475]],
    minZoom: 2,
    maxZoom: 6,
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },

  woods: {
    normalizedName: "woods",
    id: "5704e3c2d2720bac5b8b4567",
    displayName: "Woods",
    svg: "/maps/svg/Woods.svg",
    svgLayer: "Ground_Level",
    transform: [0.1855, 112.95, 0.1855, 167.85],
    coordinateRotation: 180,
    bounds: [[646, -914], [-761, 442]],
    minZoom: 2,
    maxZoom: 6,
    labels: [
      { position: [10, -3], text: "Sawmill" },
      { position: [-485, -390], text: "Scav Town" },
      { position: [-517, -210], text: "Old Sawmill" },
      { position: [-80, -680], text: "Cultist Village" },
      { position: [290, -475], text: "USEC Camp" },
      { position: [-188, 235], text: "Military Camp" },
      { position: [-5, -515], text: "Ponds", size: 80 },
      { position: [-252, -37], text: "Crash Site", size: 80 },
      { position: [239, -65], text: "Checkpoint", size: 70 },
      { position: [244, 125], text: "Shack", size: 70 },
      { position: [-16, -122], text: "Lumber", size: 70 },
      { position: [-3, -74], text: "Cabins", size: 70 },
      { position: [-234, 357], text: "Bus Stop", size: 70 },
      { position: [-327, 19], text: "Jaeger's Camp", size: 70 },
      { position: [85, -147], text: "Sniper Rock", size: 70 },
      { position: [200, -606], text: "Convoy", size: 70 },
    ],
    author: "Shebuka",
    authorLink: "https://github.com/the-hideout/tarkov-dev-svg-maps/",
  },
}
